export enum ProductMaterialCuttingSide {
    DCS_Unknown = 'DCS_Unknown',
    DCS_FrontCuttingDie = 'DCS_FrontCuttingDie',
    DCS_BackCuttingDie = 'DCS_BackCuttingDie'
}
